import React from 'react'

import { ErrorBoundary } from 'shared-components'

import { Layout } from './components/Layout'

import { BookAppointment } from './screens/BookAppoinment'
import { BookingConfirmation } from './screens/Confirmations/BookingConfirmation'
import { RequestConfirmation } from './screens/Confirmations/RequestConfirmation'
import { DatetimeSelect } from './screens/DatetimeSelect'
import { RequestAppointment } from './screens/RequestAppointment'

export const routes = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        index: true,
        element: (
          <ErrorBoundary>
            <DatetimeSelect />
          </ErrorBoundary>
        ),
      },
      {
        path: '/book-appointment',
        element: (
          <ErrorBoundary>
            <BookAppointment />
          </ErrorBoundary>
        ),
      },
      {
        path: '/request-appointment',
        element: (
          <ErrorBoundary>
            <RequestAppointment />
          </ErrorBoundary>
        ),
      },
      {
        path: '/booking-confirmation',
        element: (
          <ErrorBoundary>
            <BookingConfirmation />
          </ErrorBoundary>
        ),
      },
      {
        path: '/request-confirmation',
        element: (
          <ErrorBoundary>
            <RequestConfirmation />
          </ErrorBoundary>
        ),
      },
    ],
  },
]
